var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home h-100"},[_c('div',{staticClass:"container h-100"},[_c('main-page',{staticClass:"h-100"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }